import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/Home/Home";
import PrivacyPolicyPage from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditionsPage from "./pages/TermsAndConditions/TermsAndConditions";
import DataDeletionPage from "./pages/DataDeletion/DataDeletion";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route
        path="/terms-and-conditions"
        element={<TermsAndConditionsPage />}
      />
      <Route path="/data-deletion" element={<DataDeletionPage />} />
    </Routes>
  );
}

export default App;
